import { Box, Stack, Text } from '@stitch-fix/mode-react';
import React from 'react';
import PhotoTips from '../PhotoTips';
import type { SupportedBusinessLine } from '../Onboarding';
type ProfilePhotoSectionProps = {
  label: string;
  uploadComponent: React.ReactNode;
  photoType: 'headshot' | 'fullBody';
  businessLine: SupportedBusinessLine;
  sectionId?: string;
  sectionRef?: React.Ref<HTMLDivElement>;
};
const ProfilePhotoSection = ({
  label,
  uploadComponent,
  photoType,
  businessLine,
  sectionId,
  sectionRef
}: ProfilePhotoSectionProps) => <Box id={sectionId} ref={sectionRef} tabIndex={sectionRef ? -1 : undefined} style={{
  scrollMarginTop: '1rem'
}}>
    <Stack spacing={1.5}>
      <Text setting="title-xsmall">{label}</Text>
      <Box mb={2} minHeight={{
      sm: 0,
      lg: '235px'
    }}>
        {uploadComponent}
      </Box>
      <PhotoTips businessLine={businessLine} mode={photoType} showProfileSettingsCopy={false} />
    </Stack>
  </Box>;
export default ProfilePhotoSection;